import React, {
  useState,
  ReactNode,
  ReactElement,
  CSSProperties,
  Dispatch,
  SetStateAction,
} from 'react'
import { Icon } from '../../../components/Icon'
import Menu, { MenuItemInterface } from '../../../components/UI/UIMenu'

interface NotesAccordionItemProps {
  title: string
  isActive: boolean
  onClick: (e: React.MouseEvent<HTMLButtonElement>) => void
  children?: ReactNode
  AccordionItemStyleContainer?: CSSProperties
  AccordionItemStyle?: CSSProperties
  AccordiontitleStyle?: string
  title2?: string
  Accordiontitle2Style?: string
  isOpenMenu?: boolean
  menuItems: MenuItemInterface[]
  onClickMenu: (e: React.MouseEvent<HTMLDivElement>) => void
  isOpenMenusArray?: boolean[]
  setIsOpenMenu?: Dispatch<SetStateAction<boolean[]>> | undefined
}

const NotesAccordionItem: React.FC<NotesAccordionItemProps> = ({
  title,
  isActive,
  onClick,
  children,
  AccordionItemStyleContainer,
  AccordionItemStyle,
  AccordiontitleStyle,
  title2,
  Accordiontitle2Style,
  isOpenMenu,
  menuItems,
  onClickMenu,
  setIsOpenMenu,
  isOpenMenusArray,
}) => {
  return (
    <div
      style={AccordionItemStyleContainer}
      className="w-[100%] rounded-[16px] border border-gray2"
    >
      <button
        style={AccordionItemStyle}
        className={`w-full ${isActive ? 'rounded-t-[16px]' : 'rounded-[16px]'} h-[48px] bg-gray1 flex justify-between items-center py-4 px-4 text-left focus:outline-none`}
        onClick={onClick}
      >
        <div className="flex items-center w-full gap-2">
          <div className="flex-1 flex gap-3 items-center">
            <Icon
              name={isActive ? 'IconChevronDown' : 'IconChevronRight'}
              stroke={'#02698C'}
              strokeWidth={1.5}
              width={isActive ? 12 : 8}
              height={isActive ? 12 : 8}
            />
            <p
              className={`${AccordiontitleStyle ? AccordiontitleStyle : 'text-sm leading-6 font-semibold text-text2 mr-20'}`}
            >
              {title}
            </p>
            {title2 && (
              <p
                className={`${Accordiontitle2Style ? Accordiontitle2Style : 'text-sm leading-6 font-semibold text-bluishGreen'}`}
              >
                {title2}
              </p>
            )}
          </div>
          <Menu
            isOpen={isOpenMenu}
            items={menuItems}
            setIsOpenMenu={setIsOpenMenu}
            isOpenMenus={isOpenMenusArray}
          >
            <div
              onClick={onClickMenu}
              className={`items-center justify-between text-white py-1 px-1 flex rounded cursor-pointer ${isOpenMenu ? 'bg-gray2 border border-gray2' : 'bg-transparent'}`}
            >
              <Icon
                name={'IconDotsVertical'}
                strokeWidth={1.2}
                stroke={'#02698C'}
                width={16}
                height={16}
              />
            </div>
          </Menu>
        </div>
      </button>
      {isActive && <div>{children}</div>}
    </div>
  )
}

interface NotesAccordionProps {
  children?: ReactNode
  defaultActiveIndex?: number | null | undefined
  onClick?: () => void
}

const NotesAccordion: React.FC<NotesAccordionProps> = ({
  children,
  defaultActiveIndex,
  onClick,
}) => {
  const [activeIndex, setActiveIndex] = useState<number | null>(
    defaultActiveIndex ? defaultActiveIndex : 0
  )

  const handleItemClick = (index: number) => {
    setActiveIndex(activeIndex === index ? null : index)
  }

  return (
    <div onClick={onClick} className="w-full flex flex-col gap-[20px] mx-auto">
      {React.Children.map(children, (child, index) => {
        if (React.isValidElement(child)) {
          return React.cloneElement(child as ReactElement, {
            isActive: activeIndex === index,
            onClick: () => handleItemClick(index),
          })
        }
        return null
      })}
    </div>
  )
}

export { NotesAccordion, NotesAccordionItem }
